import { useSelector } from "react-redux"
import MovieList from "./MovieList"
import usePopular from "../Hooks/usePopular"
import useTopRated from "../Hooks/useTopRated"
import useUpcoming from "../Hooks/useUpcoming"


const SecondContainer=()=>{
    //I will call hook here and pass information to movieList
    usePopular()
    useTopRated()
    useUpcoming()
    const nowPlayingList=useSelector(store=>store.movie)
    

    
    
    return(
        <div className="bg-black  lg:mt-0">
            <div className="md:-mt-40 lg:-mt-50 relative z-20 ">
            <MovieList title={"Now Playing"} nowplaying={nowPlayingList.nowplaying}/>
            <MovieList title={"TOP Rated"} nowplaying={nowPlayingList.toprated}/>
            <MovieList title={"Popular"} nowplaying={nowPlayingList.popular}/>
            <MovieList title={"Upcoming"} nowplaying={nowPlayingList.upcoming}/>
            </div>
         
        </div>
    )
}
export default SecondContainer